import { getUserSettingsModalSearch } from 'ComponentLibrary'
import { STATIC_APP_PATHS } from 'ClientPortal/src/router/constants'
import { Navigate, useLocation } from 'react-router-dom'

export const NotificationsSettingsPage = () => {
    const location = useLocation()

    return (
        <Navigate
            to={{ pathname: STATIC_APP_PATHS.dashboard, search: getUserSettingsModalSearch(location.search, 'notifications') }}
            replace
        />
    )
}
